import { useToast } from 'vue-toast-notification';
export const ToastService = {
    open(options) {
        useToast().open(options);
    }
};
